import React, { Component } from "react";
import { Helmet } from 'react-helmet-async';
import "w3-css/3/w3.css";
import "./Time.css";
import {
  FromDayButton,
  FromHourButton,
  FromMinuteButton,
  FromMonthButton,
  FromSecondButton,
  FromWeekButton,
  FromYearButton
} from "./Button";
import { getConversion } from "./time/ConversionTracker";
import { trackConversion, trackButtonClick } from "../../utils/analytics";
export default class Times extends Component {
  render() {
    return (
      <div>
      <Helmet>
        <title>Free Time Converter - Convert Hours, Minutes, Days, Years & More | Kayannou</title>
        <meta name="description"
          content="Free online time converter. Convert between hours, minutes, seconds, days, weeks, months, and years. Fast, accurate, and easy-to-use time conversion tool." />
        <meta name="keywords"
          content="time converter, time conversion, hours to minutes, days to hours, time calculator, unit converter, convert time, free time converter, online time tool, day, hour, minute, month, second, week, year" />
        <meta name="author" content="Kayannou" />
        <meta property="og:title" content="Free Time Converter - Convert Hours, Minutes, Days, Years & More" />
        <meta property="og:description" content="Free online time converter. Convert between hours, minutes, seconds, days, and more. Fast and accurate." />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Free Time Converter - Convert Hours, Minutes, Days, Years & More" />
        <meta name="twitter:description" content="Free online time converter. Convert between hours, minutes, seconds, days, and more." />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "Time Converter",
            "description": "Free online time converter for hours, minutes, seconds, days, and more",
            "url": "https://kayannou.com/conversion/time",
            "applicationCategory": "UtilityApplication",
            "operatingSystem": "Any",
            "offers": {
              "@type": "Offer",
              "price": "0",
              "priceCurrency": "USD"
            }
          })}
        </script>
      </Helmet>
      <Container />
        </div >
    );
  }
}
class Container extends Component {
  state = {
    value: "",
    operation: ""
  };
  handleConversionButton = buttonId => {
    this.setState({ operation: buttonId });
    // Track button click
    trackButtonClick(`Time: ${buttonId}`, 'Time Conversion');
  };

  handleConversionValue = inputValue => {
    this.setState({ value: inputValue });
    // Track conversion when both value and operation are present
    if (inputValue && this.state.operation) {
      trackConversion('Time', this.state.operation, 'multiple_units', inputValue);
    }
  };

  render() {
    return (
      <div className="time-conversion-container">
        <div className="conversion-content">
          <ContainerHeader
            conversionValue={this.handleConversionValue}
            conversionresult={getConversion(
              this.state.value,
              this.state.operation
            )}
          />
          <MiddleColumn id="" conversionButton={this.handleConversionButton} />
        </div>
      </div>
    );
  }
}
class ContainerHeader extends Component {
  state = {
    inputValue: "",
    isFocused: false
  };

  handleChange = (e) => {
    const value = e.target.value;
    this.setState({ inputValue: value });
    this.props.conversionValue(value);
  };

  handleFocus = () => {
    this.setState({ isFocused: true });
  };

  handleBlur = () => {
    this.setState({ isFocused: false });
  };

  clearInput = () => {
    this.setState({ inputValue: "" });
    this.props.conversionValue("");
    if (this.input) {
      this.input.focus();
    }
  };

  render() {
    let result = this.props.conversionresult;
    const { inputValue, isFocused } = this.state;

    // Format result for better display
    const formatResult = (value) => {
      // Check if we have a valid value
      if (!value && value !== 0) return null;
      if (value === "" || value === "NaN" || value === "Infinity" || value === "-Infinity") {
        return null;
      }

      // Convert to number if it's a string
      const num = typeof value === 'string' ? parseFloat(value) : value;
      if (isNaN(num)) return null;

      if (Math.abs(num) >= 1e12) {
        return num.toExponential(4);
      } else if (Math.abs(num) >= 1000000) {
        return num.toLocaleString('en-US', { maximumFractionDigits: 2 });
      } else if (Math.abs(num) < 0.0001 && num !== 0) {
        return num.toExponential(4);
      } else {
        return num.toLocaleString('en-US', { maximumFractionDigits: 6 });
      }
    };    const formattedResult = formatResult(result);

    return (
      <div className="conversion-header">
        <div className="conversion-container">
          {/* Input Section */}
          <div className="input-section">
            <div className="input-group">
              <label className="input-label">
                <i className="fa fa-clock-o"></i>
                Time Input
              </label>
              <div className={`input-wrapper ${isFocused ? 'focused' : ''} ${inputValue ? 'has-value' : ''}`}>
                <input
                  ref={input => (this.input = input)}
                  className="conversion-input"
                  onChange={this.handleChange}
                  onFocus={this.handleFocus}
                  onBlur={this.handleBlur}
                  value={inputValue}
                  name="time"
                  type="number"
                  placeholder="Enter time conversion..."
                  min="0"
                  step="any"
                />
                {inputValue && (
                  <button
                    className="clear-button"
                    onClick={this.clearInput}
                    type="button"
                    aria-label="Clear input"
                  >
                    <i className="fa fa-times"></i>
                  </button>
                )}
                <div className="input-border"></div>
              </div>
            </div>
          </div>

          {/* Result Section */}
          <div className="result-section">
            <div className="result-group">
              <label className="result-label">
                <i className="fa fa-calculator"></i>
                Conversion Result
              </label>
              <div className="result-display">
                {formattedResult || (result && result !== "") ? (
                  <div className="result-content">
                    <span className="result-value" title={result}>{formattedResult || result}</span>
                    <div className="result-indicator">
                      <i className="fa fa-check-circle"></i>
                    </div>
                  </div>
                ) : (
                  <div className="result-placeholder">
                    <i className="fa fa-arrow-left"></i>
                    <span>Enter value and select type</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Visual Enhancement */}
        <div className="header-decoration">
          <div className="decoration-line"></div>
          <div className="decoration-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div className="decoration-line"></div>
        </div>
      </div>
    );
  }
}
class MiddleColumn extends Component {
  handleClickUnit = buttonId => {
    this.props.conversionButton(buttonId);
  };

  render() {
    return (
      <div className="conversion-buttons-section">
        <div className="buttons-header">
          <h3 className="section-title">
            <i className="fa fa-clock-o"></i>
            Select Time Unit
          </h3>
          <p className="section-description">
            Choose the time unit you want to convert from
          </p>
        </div>

        <div className="conversion-buttons-grid">
          <FromSecondButton id="sdto" sdUnit={this.handleClickUnit} />
          <FromMinuteButton id="mnto" mnUnit={this.handleClickUnit} />
          <FromHourButton id="hrto" hrUnit={this.handleClickUnit} />
          <FromDayButton id="dato" daUnit={this.handleClickUnit} />
          <FromWeekButton id="wkto" wkUnit={this.handleClickUnit} />
          <FromMonthButton id="moto" moUnit={this.handleClickUnit} />
          <FromYearButton id="yrto" yrUnit={this.handleClickUnit} />
        </div>
      </div>
    );
  }
}
